import { FileReader, FileWriter } from '@/platform'

/** 与 cg_v3 BubbleRegion @DataStrucrParse order 1～12 一致 */
export default class BubbleRegion {
    public regionId = 0
    public regionName = ''
    public startX = 0
    public startY = 0
    public regionW = 0
    public regionH = 0
    public regionUp = 0
    public regionDown = 0
    public regionLeft = 0
    public regionRight = 0
    public obligateString1 = ''
    public obligateString2 = ''

    readBin(reader: FileReader): void {
        this.regionId = reader.readInt()
        this.regionName = reader.readString()
        this.startX = reader.readInt()
        this.startY = reader.readInt()
        this.regionW = reader.readInt()
        this.regionH = reader.readInt()
        this.regionUp = reader.readInt()
        this.regionDown = reader.readInt()
        this.regionLeft = reader.readInt()
        this.regionRight = reader.readInt()
        this.obligateString1 = reader.readString()
        this.obligateString2 = reader.readString()
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.regionId)
        writer.writeString(this.regionName)
        writer.writeInt(this.startX)
        writer.writeInt(this.startY)
        writer.writeInt(this.regionW)
        writer.writeInt(this.regionH)
        writer.writeInt(this.regionUp)
        writer.writeInt(this.regionDown)
        writer.writeInt(this.regionLeft)
        writer.writeInt(this.regionRight)
        writer.writeString(this.obligateString1)
        writer.writeString(this.obligateString2)
    }
}
